module.exports = __webpack_public_path__ + "img/ico_error_connect.d000f124.svg";